import React, { useEffect, useState } from 'react';
import { Sparkles, Phone } from 'lucide-react';
import { SCHOOL } from '../lib/constants';
import { useLeadModal } from '../lib/leadModalContext';
import { trackEvent } from '../lib/analytics';

const MobileCTA = () => {
  const { openLeadModal } = useLeadModal();
  const [visible, setVisible] = useState(false);

  // Only appear after user scrolls past hero (~250px) to avoid covering initial CTAs
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 260);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleBook = () => {
    trackEvent('mobile_sticky_cta_book');
    openLeadModal('mobile-sticky-cta');
  };

  const handleCall = () => {
    trackEvent('mobile_sticky_cta_call');
  };

  return (
    <div
      aria-hidden={!visible}
      data-testid="mobile-sticky-cta"
      className={`sm:hidden fixed inset-x-0 bottom-0 z-[9998] transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {/* Top neon divider */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[color:var(--neon-red)] to-transparent opacity-70" />

      <div
        className="backdrop-blur-md bg-black/85 border-t border-[color:var(--neon-red)]/40 px-3 py-2.5 flex items-center gap-2"
        style={{ boxShadow: '0 -8px 24px rgba(255,42,42,0.18)' }}
      >
        <a
          href={SCHOOL.phoneHref}
          onClick={handleCall}
          data-testid="mobile-sticky-call-button"
          aria-label="Call Universal Kempo Karate"
          className="h-12 w-12 flex-none grid place-items-center rounded-xl border border-white/15 bg-white/5 text-white hover:bg-white/10 active:scale-95 transition-transform"
        >
          <Phone className="h-5 w-5" />
        </a>
        <button
          type="button"
          onClick={handleBook}
          data-testid="mobile-sticky-book-trial"
          className="flex-1 h-12 rounded-xl bg-[color:var(--neon-red)] hover:bg-[#ff3a3a] active:scale-[0.98] text-white font-display uppercase tracking-[0.14em] text-[13px] flex items-center justify-center gap-2 glow-red-md transition-transform"
        >
          <Sparkles className="h-4 w-4" />
          Book Free Trial Class
        </button>
      </div>
    </div>
  );
};

export default MobileCTA;
